import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import MpkStart from '../../../module/PracovnyKrok/MpkStart';
import SuccessMessages from '../../../module/SuccessMessages';

const MpkConfigPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.admin.mpk.config.withParams(type, year, index),
          heading: 'Zmena konfigurácie Pripomienkového konania',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.MPK}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Zmena konfigurácie Pripomienkového konania"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <MpkStart
                  materialDetail={materialDetail}
                  config
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default MpkConfigPage;
